module.exports = __webpack_public_path__ + "img/hde-handelsverband-deutschland.1ad30db.avif";